import { faAddressBook, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../DashboardLeftMenu';
import DashboardHeader from '../../Header/DashboardHeader';
import Spining from '../../UI/Spining/Spining';
import Axios from '../../../axios/Axios';
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from '../api/Api';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaSms } from 'react-icons/fa';
import RcsImage from "../../Dashboard/assets/img/rcs.svg-removebg-preview.png";
import dayjs from "dayjs";
import DeleteModal from './Rcs/DeleteModal';
import { handleUserLog } from '../../Utils/Utils';

const ScheduleReport = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        successShow: false,
        bgColor: "",
        errorMessage: ""
    });
    const [channel, setChannel] = useState('all');
    const [loadingBtn, setloadingBtn] = useState(false);
    const [scheduleReportList, setScheduleReportList] = useState([]);
    const [id, setId] = useState("");
    const [deletePopup, setDeletePopup] = useState(false)
    const [campaignType, setCampaignType] = useState("");
    const [showEdit, setShowEdit] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [minDateTime, setMinDateTime] = useState("");
    const [editError, setEditError] = useState({
        errorShow: false,
        editbgColor: "",
        editerrorMessage: ""
    })

    useEffect(() => {
        const updateMinDateTime = () => {
            const now = new Date();
            now.setMinutes(now.getMinutes() + 10); // add 10 min to current

            // format into yyyy-MM-ddTHH:mm for datetime-local
            const formatted = now.toISOString().slice(0, 16);
            setMinDateTime(formatted);
        };

        updateMinDateTime();

        // Refresh every 30s so min keeps rolling forward
        const timer = setInterval(updateMinDateTime, 30000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        GetScheduleData();
    }, [])

    const channelHandler = (e) => {
        setChannel(e.target.value);
        setError({ successShow: false })
        setScheduleReportList([]);
    }

    const GetScheduleData = async () => {
        setLoading(true);
        setloadingBtn(true);

        try {
            if (channel === "all") {
                const requests = [
                    { method: "getWpSchedule", type: "whatsapp" },
                    { method: "getSmsSchedule", type: "sms" },
                    { method: "getRcsSchedule", type: "rcs" },
                ].map(req =>
                    Axios.post(
                        `${NODE_HOST_URL_v1}/Schedule`,
                        { user_id: userId, method: req.method },
                        { headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "application/json" } }
                    ).then(res => ({ ...res, campaignType: req.type }))
                );

                const responses = await Promise.all(requests);

                let combinedData = [];
                responses.forEach(res => {
                    if (res.data.success) {
                        // add campaign_type to each record
                        const taggedData = res.data.data.map(item => ({
                            ...item,
                            campaign_type: res.campaignType,
                        }));
                        combinedData = [...combinedData, ...taggedData];
                    }
                });

                setScheduleReportList(combinedData);
            } else {
                // single channel case
                let method =
                    channel === "whatsapp"
                        ? "getWpSchedule"
                        : channel === "sms"
                            ? "getSmsSchedule"
                            : "getRcsSchedule";

                const { data } = await Axios.post(
                    `${NODE_HOST_URL_v1}/Schedule`,
                    { user_id: userId, method },
                    { headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "application/json" } }
                );

                if (data.success) {
                    // tag data with the current channel
                    const taggedData = data.data.map(item => ({
                        ...item,
                        campaign_type: channel,
                    }));
                    setScheduleReportList(taggedData);
                } else {
                    setError({
                        successShow: true,
                        bgColor: "alert alert-danger",
                        errorMessage: data.message,
                    });
                }
            }
        } catch (error) {
            setError({
                successShow: true,
                bgColor: "alert alert-danger",
                errorMessage: error.response?.message || "Something went wrong",
            });
        } finally {
            setLoading(false);
            setloadingBtn(false);
        }
    };

    const handleDelete = (id, campaigntype) => {
        setId(id)
        setDeletePopup(true)
        setCampaignType(campaigntype)
    }

    const CloseDeletePopup = () => {
        setDeletePopup(false)
    }

    const DeleteCampaign = async () => {
        setLoading(true);
        setloadingBtn(true);
        try {
            let method =
                campaignType === "whatsapp"
                    ? "schedule_delete"
                    : campaignType === "sms"
                        ? "delete_campaign"
                        : campaignType === "rcs"
                            ? "delete"
                            : "";

            let url =
                campaignType === "whatsapp"
                    ? `${NODE_HOST_URL}/whatsapp_campaign`
                    : campaignType === "sms"
                        ? `${NODE_HOST_URL}/sms`
                        : campaignType === "rcs"
                            ? `${NODE_HOST_URL}/rcs_campaign`
                            : null;

            if (!url) {
                console.error("Invalid campaignType");
                return;
            }

            let paramData = {
                token: userToken,
                user_id: userId,
                campaign_id: id,
                method,
            };

            const { data } = await Axios.post(url, paramData);

            if (data.success) {
                handleUserLog(
                    "",
                    "Campaign Deleted",
                    "Schedule Campaign",
                    data.message || "Campaign deleted successfully",
                    "Schedule Campaign",
                    "",
                    {
                        campaign_id: id,
                        campaign_type: campaignType
                    }
                );
                setDeletePopup(false);

                let deletedList =
                    campaignType === "rcs"
                        ? scheduleReportList.filter((x) => x._id !== id)
                        : scheduleReportList.filter((x) => x.id !== id);

                setScheduleReportList(deletedList);
                setLoading(false);
                setloadingBtn(false);
                setError({
                    successShow: true,
                    bgColor: "alert alert-success",
                    errorMessage: "Deleted Successfully",
                });
            }
            else {
                handleUserLog(
                    "",
                    "Campaign Delete Failed",
                    "Schedule Campaign",
                    data.message || "Failed to delete campaign",
                    "Schedule Campaign",
                    "",
                    {
                        campaign_id: id,
                        campaign_type: campaignType
                    }
                );
                setLoading(false);
                setloadingBtn(false);
                setError({
                    successShow: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message || "Something went wrong",
                });
            }
        } catch (error) {
            handleUserLog(
                "",
                "Campaign Delete Error",
                "Schedule Campaign",
                error?.message || "Error deleting campaign",
                "Schedule Campaign",
                "",
                {
                    campaign_id: id,
                    campaign_type: campaignType
                }
            );
            console.error("Delete campaign failed:", error);
            setLoading(false);
            setloadingBtn(false);
            setError({
                successShow: true,
                bgColor: "alert alert-danger",
                errorMessage: error.response?.message || "Something went wrong",
            });
        }
    };

    const handleSelectedDate = (e) => {
        setSelectedDate(e.target.value)
        setEditError({ errorShow: false });
    }

    const handleEditClose = () => {
        setShowEdit(false);
        setSelectedDate("");
    }

    const handleEdit = (id, campaigntype) => {
        setId(id);
        setShowEdit(true);
        setCampaignType(campaigntype);
    }

    const handleUpdate = async () => {
        const now = new Date();
        const selected = new Date(selectedDate);

        const minAllowed = new Date(now.getTime() + 10 * 60000);

        if (selected <= minAllowed) {
            setEditError({
                errorShow: true,
                editbgColor: "alert alert-danger",
                editerrorMessage: "Please select a time at least 10 minutes from now."
            });
            return;
        }
        const payLoad = {
            user_id: userId,
            method: "updateSchedule",
            Channel: campaignType === "whatsapp"
                ? "wp"
                : campaignType === "sms"
                    ? "sms"
                    : campaignType === "rcs"
                        ? "rcs"
                        : "",
            revDate: selectedDate,
            campId: id
        };

        try {
            let { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/Schedule`,
                payLoad,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (data.success) {
                handleUserLog(
                    "",
                    "Campaign Update",
                    "Schedule Campaign",
                    data.message || "Campaign schedule updated successfully",
                    "Schedule Campaign",
                    "",
                    {
                        campaign_id: id,
                        campaign_type: campaignType,
                        schedule_date: selectedDate
                    }
                );
                setShowEdit(false);
                GetScheduleData();
                setError({
                    successShow: true,
                    bgColor: "alert alert-success",
                    errorMessage: data.message || "Schedule updated successfully",
                });
            } else {
                handleUserLog(
                    "",
                    "Campaign Update Failed",
                    "Schedule Campaign",
                    data.message || "Failed to update campaign schedule",
                    "Schedule Campaign",
                    "",
                    {
                        campaign_id: id,
                        campaign_type: campaignType,
                        schedule_date: selectedDate
                    }
                );
                setError({
                    successShow: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message || "Something went wrong",
                });
            }
        } catch (error) {
            handleUserLog(
                "",
                "Campaign Update Error",
                "Schedule Campaign",
                error.message,
                "Schedul Campaign",
                "",
                {
                    campaign_id: id,
                    campaign_type: campaignType,
                    schedule_date: selectedDate
                }
            )
            console.error("Error updating schedule:", error);
            setError({
                successShow: true,
                bgColor: "alert alert-danger",
                errorMessage: error.response?.message || "Failed to update schedule. Please try again.",
            });
        }
    };

    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                {loading && <Spining />}
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    <strong>Schedule Campaign </strong>{" "}
                                </h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-12 col-xxl-5 d-flex">
                                <div className="w-100">

                                </div>
                            </div>
                        </div>

                        {error.successShow ? (
                            <div className={error.bgColor} role="alert">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="alert"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                                <div className="">{error.errorMessage}</div>
                            </div>
                        ) : null}

                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                <div className="card flex-fill ">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <label>Select channel</label>
                                                {/* <div className="input-group drop-down-icons mt-2"> */}
                                                <select value={channel} onChange={channelHandler} className="form-control">
                                                    <option value="all">All</option>
                                                    <option value="whatsapp">Whatsapp</option>
                                                    <option value="sms">SMS</option>
                                                    <option value="rcs">RCS</option>
                                                </select>
                                                {/* </div> */}
                                            </div>
                                            <div className="col-md-1">
                                                <label></label>
                                                {loadingBtn ? (
                                                    <button className="btn btn-success float-right" type="button" disabled>
                                                        <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        {/* <span className="sr-only">Loading...</span> */}
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn btn-success float-right"
                                                        onClick={GetScheduleData}
                                                    >
                                                        <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                                    </button>
                                                )}

                                            </div>
                                        </div>
                                    </div>

                                    {loading === true ? (
                                        <Spining />
                                    ) : (
                                        <div className="col-md-12 mt-2">
                                            {scheduleReportList.length > 0 ? (
                                                <>
                                                    {scheduleReportList?.map((item, i) => (
                                                        <div className="card" key={i}>
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between campaign-flex-wrap align-items-center">
                                                                    {/* Left side content */}
                                                                    <p className="mb-0 d-flex align-items-center">
                                                                        {((channel === "whatsapp" || channel === "all") && item.campaign_type === "whatsapp") &&
                                                                            <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} />
                                                                        }

                                                                        {((channel === "sms" || channel === "all") && item.campaign_type === "sms") &&
                                                                            <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} />
                                                                        }

                                                                        {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs") &&
                                                                            <img
                                                                                alt="Rcs Image"
                                                                                className="text-primary mr-2 rcs-logo-image"
                                                                                style={{ fontSize: '2em', width: '30px', height: '30px' }}
                                                                                src={RcsImage}
                                                                            />
                                                                        }

                                                                        <span>Campaign Name: </span>
                                                                        <span style={{ fontWeight: "bold" }}>
                                                                            {item.campaign_name}
                                                                        </span>
                                                                    </p>

                                                                    {/* Right side buttons */}
                                                                    <div className="d-flex">
                                                                        <button
                                                                            className="btn btn-primary btn-sm mb-2 mr-2"
                                                                            onClick={() => handleEdit(item.campaign_type === "rcs" ? item._id : item.id, item.campaign_type)} // changed for edit
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger btn-sm mb-2"
                                                                            onClick={() => handleDelete(item.campaign_type === "rcs" ? item._id : item.id, item.campaign_type)}
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </div>



                                                                <hr className="m-0 mb-1"></hr>
                                                                <div className="d-flex flex-wrap summary-data text-center">
                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label"> Campaign ID </span>
                                                                        <br />{" "}
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs") ? item._id : item.id}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label"> Template ID </span>
                                                                        <br />{" "}
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs") ? item?.pannel_temp_id : item?.template_id}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label">
                                                                            {" "}
                                                                            Country Code{" "}
                                                                        </span>{" "}
                                                                        <br />
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {item.country_code ? item.country_code : 91}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label"> total </span>{" "}
                                                                        <br />
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {item.contact_count}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label"> Campaign Cost </span>{" "}
                                                                        <br />
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs") ? parseFloat(item?.block_cr).toFixed(3) : parseFloat(item?.campaign_cost).toFixed(3)}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label"> Schedule Time </span>
                                                                        <br />{" "}
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {item.camp_start_datetime}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="summary-item mb-1">
                                                                        <span className="text-muted label"> Created Date </span>
                                                                        <br />{" "}
                                                                        <span className="textvalue  value">
                                                                            {" "}
                                                                            {item.created_date}{" "}
                                                                        </span>{" "}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            ) :
                                                <div className="card d-flex justify-content-center align-items-center ">
                                                    <h6 className="mt-2">No Record Found</h6>
                                                </div>}

                                        </div>
                                    )}

                                    <DeleteModal show={deletePopup} onClose={CloseDeletePopup} onDelete={DeleteCampaign} />

                                    {showEdit &&
                                        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                <div className="modal-content">
                                                    {/* Header */}
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Schedule Date</h5>
                                                        <button
                                                            type="button"
                                                            className="close"
                                                            onClick={handleEditClose}
                                                        >
                                                            <span>&times;</span>
                                                        </button>
                                                    </div>

                                                    {/* Body */}
                                                    {editError.errorShow ? (
                                                        <div className={editError.editbgColor} role="alert">
                                                            <button
                                                                type="button"
                                                                className="close"
                                                                data-dismiss="alert"
                                                                aria-label="Close"
                                                            >
                                                                <span aria-hidden="true">×</span>
                                                            </button>
                                                            <div className="">{editError.editerrorMessage}</div>
                                                        </div>
                                                    ) : null}
                                                    <div className="modal-body d-flex justify-content-center">
                                                        <div className="input-group w-75">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">
                                                                    <FontAwesomeIcon icon={faAddressBook} />
                                                                </span>
                                                            </div>
                                                            <input
                                                                type="datetime-local"
                                                                className="form-control"
                                                                min={minDateTime}   // ⬅ ensures earliest selectable time is now+10min
                                                                value={selectedDate}
                                                                onChange={handleSelectedDate}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Footer */}
                                                    <div className="modal-footer justify-content-center">
                                                        <button
                                                            className="btn btn-secondary"
                                                            onClick={handleEditClose}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={handleUpdate}
                                                            disabled={!selectedDate}
                                                        >
                                                            Update
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {/* <WhatsAppCampaignListPreview templateDetails={this.state.templateDetails} openTemplatePopup={this.state.openTemplatePopup} closePopup={this.closePopup} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                <DashboardFooter />
            </div>
        </div>
    )
}

export default ScheduleReport
